import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import CallToAction from "../components/cta"
import Layout from "../components/layout"
import SEO from "../components/seo"


const Team = () => (
  <Layout>
    <SEO title="ScrapeOwl Team" />

    <div className="article-text">
      <Container>
        <Row>
          <Col md="8" lg="8" className="article-col">
            <article>
              <h1>Team</h1>
              <p>ScrapeOwl was created by a small two-person team that is dedicated to helping solve your data extraction needs.</p>
            </article>

            <div className="creators">

              <div className="creator">
                <h2 className="creatorName">
                  Athar Ahmed
                </h2>
                <h3 className="creatorRole">
                  Software Engineer
                </h3>
                <a href="mailto:athar@scrapeowl.com" className="creatorContact">
                  athar@scrapeowl.com
                </a>
                <p className="creatorDesc">
                  Athar is a seasoned software engineer that has been interacting with data in various forms since 2010. He has built dozens of applications and services for clients all over the world.
                </p>
              </div>

              <div className="creator">
                <h2 className="creatorName">
                  Ziyad Basheer
                </h2>
                <h3 className="creatorRole">
                  Product Designer
                </h3>
                <a href="mailto:athar@scrapeowl.com" className="creatorContact">
                  ziyad@scrapeowl.com
                </a>
                <p className="creatorDesc">
                  Ziyad is a optimizer of functionality, performance, and aesthetic and believes that they're all intertwined and that we truly cannot have one without the others. Ziyad builds things and helps others build them, you can also find him on <a href="https://twitter.com/ziyadbasheer">twitter.</a>
                </p>
              </div>

              <div className="creator">
                <h2 className="creatorName">
                  Fajar Siddiq
                </h2>
                <h3 className="creatorRole">
                  Community Adovcate
                </h3>
                <p className="creatorDesc">
                  Fajar Siddiq is a seasoned founder with 15 years of experience. He build communities since year 2005 & a prominent influencer who have help many local startups, bootstrapped & independent founders together online from launching their products to getting feedbacks. Find him on <a href="https://twitter.com/fajarsiddiqfs">twitter.</a>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>

    <CallToAction />

  </Layout>
)

export default Team
